module.exports = __webpack_public_path__ + "img/sport-26-@3x.8969830c.png";